import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Main from './pages/Main';
import CSM from '../src/pages/contents/CreateSvgMarker/CSM';
import CSP from '../src/pages/contents/CreateSvgPolygon/CSP';
import { AnimatePresence } from 'framer-motion';
import PageTransition from "./animations/PageTransition";

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <Main/>
//   },
//   {
//     path: "/create-svg-marker",
//     element: <CSM/>
//   },
//   {
//     path: "create-svg-polygon",
//     element: <CSP/>
//   },
// ]);

// function App() {
//   return (
//     <div className="App">
//       <RouterProvider router={router} />
//     </div>
//   );
// }

function AnimatedRoutes() {
  const location = useLocation();

  return (
      <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
              <Route
                  path="/" 
                  element={
                      <PageTransition>
                          <Main />
                      </PageTransition>
                  } 
              />
              <Route
                  path="/create-svg-marker" 
                  element={
                      <PageTransition>
                          <CSM />
                      </PageTransition>
                  } 
              />
              <Route
                  path="/create-svg-polygon" 
                  element={
                      <PageTransition>
                          <CSP />
                      </PageTransition>
                  } 
              />
          </Routes>
      </AnimatePresence>
  );
}

function App() {
  return (
      <Router>
          <AnimatedRoutes />
      </Router>
  );
}

export default App;
